<template>
  <section>
    <article>
      <infinite-scroll class="stories" :callback="fetchMore">
        <project-card :class="{ 'column is-one-quarter-widescreen is-one-third-tablet' : !isMobile }" v-for="story in stories" :projectID="story.id" :key="story.id"></project-card>
      </infinite-scroll>
      <div class="loader" v-if="loading"></div>
    </article>
    <article v-if="!loading && stories.length === 0">
      <p>{{placeholder}}</p>
    </article>
  </section>
</template>

<script>
import InfiniteScroll from '@/components/Controls/InfiniteScroll'

import componentState from '@/mixins/component-state'
import ProjectCard from '@/components/Cards/ProjectCards'

import mixin from './mixin'

export default {
  props: ['user', 'profile'],
  components: {
    ProjectCard,
    InfiniteScroll
  },
  mixins: [componentState, mixin],
  data: function () {
    return {
      stories: [],
      placeholder: 'Stories you create will appear here'
    }
  },
  watch: {
    user: function () {
      this.offset = 0
      this.loading = false
      this.hasMore = true
      this.stories = []
      this.getTabContent('story')
    }
  },
  mounted: function () {
    this.getTabContent('story')
  },
  methods: {
    fetchMore: function () {
      this.getTabContent('story')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/utils.scss";

.stories {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @include mobile {
    width: 100vw;
    margin: 0 -1rem;
  }
}
.loader {
  display: block;
  font-size: 2rem;
  margin: 1rem auto;
}
</style>
